<template>
  <vx-card>
    <validation-observer ref="validator" #default="{valid}">
      <b-form
        :class="[inline ? 'gap-2 items-center' : '']"
        :inline="inline"
        @submit.prevent="onSubmit"
        @reset.prevent="clear"
        @reset="onReset"
        v-if="show">

        <validation-provider
          #default="validationContext"
          :name="$t('knowledge_item_title')"
          rules="required"
          class="flex-grow"
          slim>
          <b-form-group
            id="input-group-1"
            :label="$t('knowledge_item_title')"
            label-for="knowledge_item_title">
            <b-form-input
              id="knowledge_item_title"
              v-model="item.title"
              :placeholder="$t('knowledge_item_subject')"
              class="required">
            </b-form-input>
            <b-form-invalid-feedback :class="[{'absolute': inline}]">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <validation-provider
          #default="validationContext"
          :name="$t('knowledge_item_category')"
          rules="required"
          class="flex-grow"
          slim>
        <b-form-group
          id="input-group-3"
          :label="$t('knowledge_item_category')"
          label-for="knowledge_item_category">
          <b-form-select
            id="knowledge-item-category"
            class="required-select"
            :options="knowledgeCategories"
            text-field="name"
            value-field="id"
            v-model="item.knowledge_category_id"/>
            <b-form-invalid-feedback :class="[{'absolute': inline}]">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
        </b-form-group>
        </validation-provider>
        <validation-provider
          #default="validationContext"
          :name="$t('knowledge_item_description')"
          rules="min:10"
          class="flex-grow"
          slim>
          <b-form-group
            id="input-group-2"
            :label="$t('knowledge_item_description')"
            label-for="knowledge_item_description">
            <simple-editor v-model="item.description" class="mb-2"/>
          </b-form-group>
        </validation-provider>
        <div class="flex flex-row justify-end gap-4">
          <b-button type="submit"
                    variant="primary"
                    :disabled="!valid">Salvar</b-button>
          <b-button @click="goBack" variant="outline-secondary">Voltar</b-button>
        </div>

        <b-row class="m-0" v-if="isEdit()">
          <b-col
            lg="12">
            <h5 class="mt-2 mb-0">{{$t('knowledge_subtitle_document')}}</h5>
            <vs-divider></vs-divider>
          </b-col>
        </b-row>

         <b-row class="pt-2 pb-2" v-if="isEdit()">
          <b-col
            lg="12"
            md="12">
            <vue-dropzone
              id="upload"
              ref="fileUploadZone"
              @vdropzone-processing="dropzoneChangeUrl"
              v-on:vdropzone-success="successSendFile"
              v-on:vdropzone-error="error"
              v-on:vdropzone-file-added="added"
              v-on:vdropzone-queue-complete="complete"
              :use-font-awesome="true"
              :options="dropzoneOptions"
              :use-custom-dropzone-options="true"
              :useCustomSlot="true"
              @vdropzone-file-added="fileAdded">
              <div class="dropzone-custom-content">
                Arraste e solte para enviar um arquivo
                <p class="separator">
                  <span class="separator-span"> ou </span>
                </p>
                <b-button
                  type="button"
                  class="btn waves-effect outline-primary"
                  variant="outline-secondary">Selecionar</b-button>
              </div>
            </vue-dropzone>
          </b-col>
        </b-row>

        <b-row class="pt-2" v-if="isEdit()">
          <b-col md="12">
            <media-list :medias="files"
                        :show-delete="true"
                        :action-on-click="false"
                        @deleteMedia="deleteMedia"/>
          </b-col>
        </b-row>

      </b-form>
    </validation-observer>
  </vx-card>
</template>

<script>

import SelectSuggestion from '@/components/SelectSuggestion.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, min, email } from '@validations'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import standard from '@/services/standard'


import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BButton,
  BFormInvalidFeedback,
  VBTooltip,
} from 'bootstrap-vue'

import KnowledgeService from '@/services/api/KnowledgeService'
import MediaList from '@/components/media/MediaList.vue'
import SimpleEditor from '@/components/SimpleEditor.vue'

export default {
   directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    SelectSuggestion,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BButton,
    ValidationObserver,
    ValidationProvider,
    BFormInvalidFeedback,
    vueDropzone: vue2Dropzone,
    MediaList,
    SimpleEditor
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    service: null,
    item: {
      title: '',
      description: '',
      knowledge_category_id: ''
    },
    dropzoneOptions: {
      headers: { Authorization: `Bearer ${standard.token()}` },
      url: 'url', //set in dropzoneChangeUrl
      addRemoveLinks: true,
      autoProcessQueue: true,
      timeout: 180000,
      thumbnailWidth: 200,
      parallelUploads: 20,
      maxFiles: 20,
      //maxFiles: 1,
      createImageThumbnails: true,
      dictInvalidFileType: 'Arquivos somente no formato PDF',
      dictRemoveFile: 'Remover arquivo',
    },
    knowledgeCategory: {},
    knowledgeCategories: [],
    files: [],
    show: true,
    required, email, min
  }),
  methods: {
    loadKnowledgeCategories() {
      return this.service.getCategories().then(
        response => {
          this.knowledgeCategories = [
            ...response
          ]
        },
        error => {
          console.error('whoops')
        }
      )
    },
    onReset() {
      console.log('ret')
    },
    onSubmit() {
      const item = this.item
      if (this.id) {
        item.id = this.id
      }
      this.$vs.loading()
      return this.service.createOrUpdate(item).then(
        response => {
          this.notifySuccess(this.$vs, 'Operação realizada com sucesso!')
          this.item.title = response.title
          this.item.description = response.description
          this.item.knowledge_category_id = response.knowledge_category_id
          this.$router.replace({
            name: 'knowledge-item-edit',
            params: {
              id: response.id
            }
          })
        },
        error => {
          this.notifyError(this.$vs, 'Erro! não foi possível concluir esta operação')
          console.error(error)
        }
      ).finally(
        () => this.$vs.loading.close()
      )
    },
    getData() {
      return this.service.read(this.id).then(
        response => {
          this.item.description = response.description
          this.item.title = response.title
          this.item.knowledge_category_id = response.knowledge_category_id
          this.files = response.files
        },
        error => {
          console.error('oh no!')
        }
      )
    },
    goBack() {
      this.$router.push({
        name: 'knowledge-item-index'
      })
    },
    isEdit(){
      return (this.id != null || this.id != undefined)
    },
    dropzoneChangeUrl(){
      this.$refs.fileUploadZone.setOption('url', this.getFileUploadUrl);
    },
    successSendFile(data) {
      this.getData() //reload with files upload
      this.$vs.loading.close()
      this.notifySuccess(this.$vs, "Documento anexado com sucesso!")
      this.$refs.fileUploadZone.removeAllFiles()
    },
    deleteMedia(media){
      this.$vs.loading()
      const handlingId = _.get(this.item, 'id')

      this.service.deleteAttachment(this.id, media.id).then(
        data => {
          this.notifySuccess(this.$vs, "Anexo removido!")
          //Update list files
          let newListfiles = _.remove(this.files, function(element) {
            return element.id !== media.id
            })
          this.files = newListfiles
        },
        error => {
          this.notifyError(this.$vs, "Não foi possível remover o anexo.")
        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    },
  },
  computed: {
    getFileUploadUrl() {
      const base = `${process.env.VUE_APP_API_BASE_URL}/api/v2`
      return `${base}/knowledge/items/${this.id}/files`
    },
  },
  beforeMount() {
    this.service = KnowledgeService.build(this.$vs)

    this.show = false
    const bootstrapRequests = []

    this.$vs.loading()

    bootstrapRequests.push(this.loadKnowledgeCategories())

    if (this.id) {
      bootstrapRequests.push(this.getData(this.id))
    }

    Promise.all(bootstrapRequests).then(
      () => this.show = true
    ).finally(
      () => this.$vs.loading.close()
    )
  },
}
</script>


<style lang="scss" scoped>
  ::v-deep .vs-popup {
    width: 800px !important;
  }
</style>
